import { render, staticRenderFns } from "./announcementCard.vue?vue&type=template&id=8d9a0b92"
import script from "./announcementCard.vue?vue&type=script&lang=js"
export * from "./announcementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports